export default "__VITE_ASSET__DcBNvaVz__"